<template>
  <div>
    <v-dialog v-model="dialogOpen" width="440" @keydown.stop.esc="dialogOpen = false">
      <template v-slot:activator="{ props }">
        <slot name="activator" :props="props"></slot>
      </template>

      <div class="dialog">
        <div class="d-flex mb-6 align-center">
          <v-icon size="large" class="mr-3 mt-3" style="margin-top: 2px;">mds:group_add</v-icon>
          <span class="text-title mr-3 mt-3 text-truncate">Invite members</span>
          <v-spacer/>
          <help-dialog-share-project #default="{ props }">
            <v-btn
              variant="text"
              size="small"
              icon="mdi-help-circle-outline"
              v-bind="props"
              class="mr-2"
              :disabled="$store.state.isWorkflowDisabled"
            />
          </help-dialog-share-project>
          <v-btn variant="text" color="grey" @click="dialogOpen = false" icon="mdi-close">
          </v-btn>
        </div>

        <div class="mb-6">
          <invite-team-members-field v-model="invites" ref="membersField"/>
          <div class="text-subtitle mb-3">Members in '{{ project ? project.name : "" }}' with access</div>
          <base-team-member v-for="member in listTeamMembers" :teamMember="member" :project="project" :key="member.id"/>
        </div>

        <div class="d-flex">
          <v-spacer/>
          <v-btn variant="flat" size="large" @click="saveAndClose">
            {{ invites?.length > 0 ? 'Invite ' + invites.length + ' new members' : 'Cancel' }}
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <info-message-dialog
      v-if="infoMessageDialogData"
      :is-open="infoMessageDialogData.isOpen"
      :title="infoMessageDialogData.title"
      :message="infoMessageDialogData.message"
      @close="infoMessageDialogData = null"
    >
      <template #footer>
        <div class="d-flex ga-2">
          <v-btn variant="outlined" size="large" @click="infoMessageDialogData = null">
            Discard
          </v-btn>
          <v-btn variant="flat" size="large" @click="inviteAndClose">
            Invite anyway
          </v-btn>
        </div>
      </template>
    </info-message-dialog>
  </div>
</template>
<script>
import HelpDialogShareProject from '@/components/HelpDialogShareProject.vue'
import InviteTeamMembersField from '@/components/InviteTeamMembersField.vue'
import BaseTeamMember from '@/components/BaseTeamMember.vue'
import workflowApi from '@/api/workflowApi'
import { mapState, mapGetters } from 'vuex'
import InfoMessageDialog from '@/components/InfoMessageDialog.vue'

export default {
  name: 'workflow-share-dialog',
  components: { BaseTeamMember, InviteTeamMembersField, InfoMessageDialog, HelpDialogShareProject },
  props: {
    isShareEnabled: {},
    openShareDialog: {},
    workflow: {}
  },
  data () {
    return {
      infoMessageDialogData: null,
      dialogOpen: false,
      invites: [],
      accessLevelItems: [{
        name: 'No access',
        value: 'PRIVATE'
      }, {
        name: 'Anyone with link can view',
        value: 'READ'
      }]
    }
  },
  computed: {
    ...mapState({
      listTeamMembers: state => state.teamMembers.teamMembers,
      subscriptionUsers: state => state.payments.subscriptionUsers
    }),
    ...mapGetters({
      project: 'projectMemberships/activeProject'
    }),
    numInvites () {
      return this.$refs.membersField?.addMembersLength || 0
    },
    accessLevel: {
      get: function () {
        return this.workflow.accessLevel || this.accessLevelItems[0]
      },
      set: function (value) {
        workflowApi.updateWorkflowNoHistoryMutation(
          this.$route.params.projectId,
          {
            id: this.$route.params.id,
            expectedVersion: this.workflow.version,
            accessLevel: value
          }
        )
      }
    },
    windowLocation: {
      get: function () {
        return window.location
      }
    }
  },
  methods: {
    saveAndClose () {
      const subscriptionUserEmails = this.subscriptionUsers.map(user => user.email)
      const notSubscriptionMembers = this.invites.reduce((acc, email) => {
        if (!subscriptionUserEmails.includes(email)) {
          acc.push(email)
        }
        return acc
      }, [])

      console.log('notSubscriptionMembers', notSubscriptionMembers)

      if (notSubscriptionMembers.length > 0) {
        const message = notSubscriptionMembers.length === 1
          ? `User ${notSubscriptionMembers[0]} is not included in your subscription and may not have an active subscription.`
          : `The following users are not included in your subscription and may not have an active subscription: ${notSubscriptionMembers.join(', ')}.`

        this.infoMessageDialogData = {
          message,
          isOpen: true
        }
      } else {
        this.inviteAndClose()
      }
    },
    inviteAndClose () {
      this.infoMessageDialogData = null
      this.$refs.membersField.inviteTeamMembers()
      this.dialogOpen = false
    },
    saveLinkToClipboard () {
      navigator.clipboard.writeText(this.windowLocation)
      this.$store.commit('snackbar/showMessage', {
        content: 'Link copied. You can share it with your team!',
        timeout: 3000
      }, { root: true })
    },
    handleToogleDialog (val) {
      if (!val) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
.dialog {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #FCFCFC;
  background: #FCFCFC;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
}

.access-level-select {
  border: none; /* Remove default border */
  outline: none; /* Remove outline when clicked */
  appearance: none; /* Remove default styling on some browsers */
  margin: 5px;

  max-width: 100%;

  :focus {
    outline: none;
  }
}

.access-level-select option {
  border: none; /* Remove border on option elements */
  padding: 5px; /* Add some padding for visual separation */
  font-size: 16px; /* Set a font size */
  color: #333; /* Set font color */
  appearance: none;
}

.access-disabled .v-select__selection {
  color: grey !important;
}
</style>
